export default __webpack_public_path__ + "static/media/dnd2.fcbedece.png";